"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.benefitsFragment = void 0;
var _fetching = require("@ori/fetching");
const benefitsFragment = exports.benefitsFragment = (0, _fetching.gql)`
  fragment Benefits on EditorialBenefits {
    __typename
    id
    title
    benefits {
      __typename
      caption
      icon
      content {
        __typename
        text
        textLinks {
          id
          title
          relativeUrl
        }
      }
    }
  }
`;
